"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const rfid_tag_action_1 = __importDefault(require("./rfid-tag.action"));
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const modal_1 = require("components/molecules/modal");
const tab_1 = __importDefault(require("components/molecules/tabs/tab"));
const dump_truck_1 = __importDefault(require("./dump-truck"));
const hauler_1 = __importDefault(require("./hauler"));
const RfidTag = () => {
    const { isLoading, isError, errorMessage } = (0, store_1.useAppSelector)(state => state.configuration.rfidTag);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const rfidTabs = [
        { index: 0, labels: 'Dump Truck' },
        { index: 1, labels: 'Hauler' }
    ];
    const dispatch = (0, react_redux_1.useDispatch)();
    const [tabsMode, setTabsMode] = (0, react_1.useState)('Dump Truck');
    const onChangeTab = (mode) => {
        setTabsMode(mode);
        dispatch(rfid_tag_action_1.default.onClickMutation({ mutationMode: false, isLoading: true }));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { title: 'RFID Tag', theme: appTheme, isLoading: isLoading, isAddNew: false }), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { marginBottom: 24 } }, { children: (0, jsx_runtime_1.jsx)(tab_1.default, { tabs: rfidTabs, onChangeTab: onChangeTab }) })), tabsMode === 'Dump Truck' ? (0, jsx_runtime_1.jsx)(dump_truck_1.default, {}) : (0, jsx_runtime_1.jsx)(hauler_1.default, {}), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, errorMessage: errorMessage, onClose: () => dispatch(rfid_tag_action_1.default.onCloseError()), style: { 'zIndex': 10 } })] }));
};
exports.default = RfidTag;
